import { render, staticRenderFns } from "./ScrollUp.vue?vue&type=template&id=5bc8cbe9&scoped=true&"
import script from "./ScrollUp.vue?vue&type=script&lang=js&"
export * from "./ScrollUp.vue?vue&type=script&lang=js&"
import style0 from "./ScrollUp.vue?vue&type=style&index=0&id=5bc8cbe9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc8cbe9",
  null
  
)

export default component.exports